import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
function FooterMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3].map(i => <div key={i} className="h-5 w-24 bg-white/10 animate-pulse rounded" data-index={i} />)}
      </div>;
  }
  const items = menuItems && menuItems.length > 0 ? menuItems : [{
    id: 'home',
    label: 'Home',
    href: '/'
  }, {
    id: 'services',
    label: 'Services',
    href: '/services'
  }, {
    id: 'contact',
    label: 'Contact',
    href: '/contact'
  }];
  return <ul className="flex flex-col gap-3">
      {items.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-white/80 hover:text-white transition-colors font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function ProjectBase() {
  const currentYear = new Date().getFullYear();
  const email = "info@qstgeo.com";
  const phone = "N/A";
  const address = "https://www.qstgeo.com/";
  const hours = "N/A";
  return <section id="project-base" className="dark bg-[#362242] text-white py-16 px-4 sm:px-8">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://fluent-gnu.10web.cloud/wp-content/uploads/2026/02/image_5fezpuzw.png" alt="QST Geotechnical" className="h-7 w-auto object-contain !text-transparent !bg-transparent ![margin:0px_5px_0px_5px]" />
            </Link>
            
            <div className="flex flex-col gap-4 text-sm font-sans text-white/80">
              {address && address !== "N/A" && <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#6B28A1] shrink-0 mt-0.5" />
                  <span>{address}</span>
                </div>}
              
              {phone && phone !== "N/A" && <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-[#6B28A1] shrink-0" />
                  <Link to={`tel:${phone}`} className="hover:text-white transition-colors">
                    {phone}
                  </Link>
                </div>}
              
              {email && email !== "N/A" && <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#6B28A1] shrink-0" />
                  <Link to={`mailto:${email}`} className="hover:text-white transition-colors">
                    {email}
                  </Link>
                </div>}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xs uppercase tracking-widest font-bold text-white">
              Hours of Operation
            </h3>
            
            <div className="flex items-start gap-3 text-sm font-sans text-white/80">
              <Clock className="w-5 h-5 text-[#6B28A1] shrink-0 mt-0.5" />
              <div className="flex flex-col gap-2">
                {hours !== "N/A" ? <p>{hours}</p> : <p>Hours of Operation<div>Monday - Saturday: 7:00 AM - 5:00 PM</div><div><br /></div><div>Emergency &amp; After-Hours Service</div><div>For urgent site work, emergency soil testing, or time-sensitive projects, our team is available 24/7 by phone.</div></p>}
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xs uppercase tracking-widest font-bold text-white">
              Quick Links
            </h3>
            
            <MenuProvider menu_id="44" className="w-full">
              <FooterMenu />
            </MenuProvider>
            
            <div className="pt-2">
              <Button variant="secondary" className="rounded-full w-full sm:w-auto bg-[#CECECE] text-black hover:bg-white border-none" asChild>
                <Link to="#">Book Now</Link>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-[#6B28A1] h-px opacity-50" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/60 font-sans">
          <p>&copy; {currentYear} QST Geotechnical. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}